import Q from 'q';

import API from 'js/lib/api';

import type { SignupParams } from 'bundles/authentication/shared/types/sharedTypes';

export default ({
  email,
  name,
  password,
  botManagerToken,
  botManagerType,
  botManagerError,
  redirectTo,
  verificationEmailRedirectUrl,
  skipWelcomeEmail,
}: SignupParams) => {
  const api = API('', { type: 'post' });

  // verifyEmail is a required field on BE
  const data = {
    email,
    verifyEmail: email,
    name,
    password,
    botManagerToken,
    botManagerType,
    ...(botManagerError ? { botManagerError } : null),
    redirectTo,
    verificationEmailRedirectUrl,
    skipWelcomeEmail,
  };

  return Q(api.post('api/register/v1', { data }));
};
